module.exports = fox._r("images/promo/tutorial/07.png", __webpack_public_path__ + "_/common/images/promo/tutorial/07.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/07.png
// module id = 655
// module chunks = 2